import { EmployeeService } from "../EmployeeService/employee.service"
import { EmployeeDelegate } from "../EmployeeService/employee.delegate"
import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';
import { AuthenticationService } from '../AuthenticationService/authentication.service';
import { InitializationModel, InitializationStatusCodes } from '../Initialization';

export class EmployeeServiceFactory
{
    static create(config: IAppConfig, spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService, initServiceModel?: InitializationModel
    ): EmployeeService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new EmployeeDelegate(httpProvider);

        return new EmployeeService(delegate, authenticationService, initServiceModel);
    }
}